import React, { useMemo } from 'react'
import { Collection, GuildHomeHero } from '@/types/codegen-contentful'
import { SweepstakeObject, TheatricalReleaseObject } from '@/types/codegen-federation'
import { ReactFCC } from '@/types/react'
import { Maybe } from '@/utils/types'

interface LandingContextProps {
  guildHomeHero?: Maybe<GuildHomeHero>
  watchForFree?: Maybe<Collection>
  children: React.ReactNode
  members?: number
  lastUpdated?: string
  releases?: TheatricalReleaseObject[]
  sweepstakes?: SweepstakeObject[]
}

interface LandingContextState {
  guildHomeHero?: Maybe<GuildHomeHero>
  watchForFree?: Maybe<Collection>
  members?: number
  lastUpdated?: string
  releases?: TheatricalReleaseObject[]
  sweepstakes?: SweepstakeObject[]
}

const defaultValue = {
  guildHomeHero: null,
  watchForFree: null,
  members: 360000,
  lastUpdated: 'Jan 22, 2025',
  releases: [],
  sweepstakes: [],
}

export const LandingContext = React.createContext<LandingContextState>(defaultValue)

export const LandingProvider: ReactFCC<LandingContextProps> = ({
  children,
  guildHomeHero,
  watchForFree,
  members,
  lastUpdated,
  releases,
  sweepstakes,
}) => {
  const value = useMemo(() => {
    return {
      guildHomeHero,
      watchForFree,
      members,
      lastUpdated,
      releases,
      sweepstakes,
    }
  }, [guildHomeHero, watchForFree, members, lastUpdated, releases, sweepstakes])

  return <LandingContext.Provider value={value}>{children}</LandingContext.Provider>
}

export const useLanding = () => React.useContext(LandingContext)
